import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { BarChart3, Users, TrendingUp, CheckCircle } from 'lucide-react';

interface AnalyticsMetrics {
  totalSessions: number;
  activeSessions: number;
  completedSessions: number;
  totalVotes: number;
  averageVotesPerSession: number;
  totalVariants: number;
  winningVariants: number;
}

interface Props {
  metrics: AnalyticsMetrics;
}

export const AnalyticsMetricsGrid = ({ metrics }: Props) => {
  const metricCards = [
    {
      title: 'Total Sessions',
      value: metrics.totalSessions,
      icon: BarChart3,
      description: `${metrics.activeSessions} active, ${metrics.completedSessions} completed`,
    },
    {
      title: 'Total Votes',
      value: metrics.totalVotes,
      icon: Users,
      description: `${metrics.averageVotesPerSession.toFixed(1)} avg per session`,
    },
    {
      title: 'Total Variants',
      value: metrics.totalVariants,
      icon: TrendingUp,
      description: `${metrics.winningVariants} marked as winners`,
    },
    {
      title: 'Completion Rate',
      value: `${metrics.totalSessions ? ((metrics.completedSessions / metrics.totalSessions) * 100).toFixed(0) : 0}%`,
      icon: CheckCircle,
      description: `${metrics.completedSessions} of ${metrics.totalSessions} sessions`,
    },
  ];

  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
      {metricCards.map((metric) => {
        const Icon = metric.icon;
        return (
          <Card key={metric.title} className="bg-white/5 border-white/10">
            <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
              <CardTitle className="text-sm font-medium text-gray-400">{metric.title}</CardTitle>
              <Icon className="h-4 w-4 text-blue-400" />
            </CardHeader>
            <CardContent>
              <div className="text-2xl font-bold text-white">{metric.value}</div>
              <p className="text-xs text-gray-500 mt-1">{metric.description}</p>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
};
